import { useAuthContext } from '/src/hooks';

export function useAccountNumber(asSegments = false) {
  const { currentAccount } = useAuthContext();

  const accountNumber = currentAccount?.paddedId ?? null;

  if (asSegments) {
    return accountNumber ? [accountNumber.slice(0, 4), accountNumber.slice(4, 8)] : [null, null];
  }

  return [accountNumber];
}
